import React from 'react';
import { Link } from 'react-router-dom';
import {history} from '../routers/AppRouter';
import API from './api';

class NotFoundPage extends React.Component{

  state = {
    notfoundImage:''
  }

  componentWillMount = () =>{
    API.get(`settings`)
      .then(res => {
        const settings = res.data;
        this.setState({
          notfoundImage:settings.not_found
        });
      });
  }

  render(){
    return(
        <div className="notFoundPage">
          <div className="intro v-center">
            <div className="notFoundImg">
              <img src={this.state.notfoundImage}/>
              <p><Link className="button black" to={{pathname: '/', state: { prevPath: location.pathname }}}>Go home</Link></p>
            </div> 
          </div>
        </div>
    );
  }
  
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js